import DeclarationModal from "../../components/electralink/DeclarationModal";

import { useDashboard } from "./useDashboard";
import { useVisibleTiles } from "./useVisibleTiles";

const Dashboard = () => {
  const { firstName, formattedDate, modalOpen, closeModal, proceedToDestination, onTileClick } =
    useDashboard();

  const visibleTiles = useVisibleTiles();

  return (
    <div className="dashboard">
      <div className="container-fluid py-4">
        <header className="mb-5">
          <h1 className="display-5 fw-bold text-dark">Welcome, {firstName}</h1>
          <p className="text-muted small">It&apos;s {formattedDate}!</p>
        </header>

        <section className="mw-800">
          {" "}
          <h2 className="h4 mb-4 text-secondary">Quick Access</h2>
          <div className="d-flex flex-column gap-3">
            {visibleTiles.map((tile) => (
              <button
                key={tile.id}
                data-testid={`dashboard-tile-${tile.id}`}
                className="dashboard__tile-row shadow-sm"
                onClick={() => {
                  onTileClick(tile.path, tile.requiresLoa || false);
                }}
              >
                <div className="dashboard__icon-box">
                  <tile.icon size={24} />
                </div>

                <div className="flex-grow-1">
                  <h3 className="h6 mb-1 fw-bold text-dark">{tile.title}</h3>
                  {tile.description && <p className="small text-muted mb-0">{tile.description}</p>}
                </div>

                {tile.visible === false && (
                  <span className="badge rounded-pill bg-warning text-dark ms-2">Hidden</span>
                )}

                <div className="text-muted opacity-25 ms-3">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </button>
            ))}
          </div>
        </section>
      </div>

      <DeclarationModal
        key={modalOpen ? "open" : "closed"}
        isOpen={modalOpen}
        onClose={closeModal}
        onProceed={proceedToDestination}
      />
    </div>
  );
};

export default Dashboard;
